import { Box, CircularProgress, Container, Tab, Tabs } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Perustiedot, Asiakas, Tuotteet, Laskutus, Lisatiedot } from '@/components/KoriList/KoriDetailsTabs';
import { useKoriData } from '@/hooks/useKoriDetails';
import { useToastError } from '@/hooks/useToastError';

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Container disableGutters>
          {children}
        </Container>
      )}
    </div>
  );
};

// Ilmeisesti jotain saatavuushommia
const a11yProps = (index) => {
  return {
    'id': `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
};

const KoriDetails = ({ id, onEditNimi }) => {
  const { data, loading, error } = useKoriData(id);
  const { t } = useTranslation();
  useToastError(error, t('koriDetails.fetchError'));

  const [tab, setTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  if (!data) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) return null;

  if (!loading) {
    return (
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderTop: 1, borderColor: 'divider' }}>
          <Tabs value={tab} variant="scrollable" scrollButtons="auto" onChange={handleTabChange} aria-label={t('koriDetails.categories')}>
            <Tab label={t('koriDetails.basicInfo')} {...a11yProps(0)} />
            <Tab label={t('koriDetails.additionalInfo')} {...a11yProps(1)} />
            <Tab label={t('koriDetails.products')} {...a11yProps(2)} />
          </Tabs>
        </Box>
        <TabPanel value={tab} index={0}>
          <Perustiedot data={data} onEditNimi={onEditNimi} />
        </TabPanel>
        <TabPanel value={tab} index={1}>
          <Lisatiedot data={data} />
        </TabPanel>
        <TabPanel value={tab} index={2}>
          <Tuotteet tuotteet={data.tuotteet} />
        </TabPanel>
        <TabPanel value={tab} index={3}>
          <Laskutus data={false} />
        </TabPanel>
        <Container disableGutters>
          <Asiakas asiakasData={data.korinAsiakas.rekisterinAsiakas} />
        </Container>
      </Box>
    );
  };
};

export default KoriDetails;
